import { Component, HostBinding, ViewEncapsulation } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';

@Component({
  selector: 'form-password-field',
  standalone: false,
  encapsulation: ViewEncapsulation.None,
  styles: [
    '.form-password-field { display:flex; flex: 1;.p-password {display: flex; flex: 1} input {display: flex; flex: 1}}',
  ],
  template: `
    <p-iftalabel class="flex-1">
      <p-password
        [formControl]="formControl"
        [formlyAttributes]="field"
        class="w-full flex"
        [pTooltip]="
          field.props['translate']
            ? (field.props['tooltip'] || '' | translate)
            : field.props['tooltip']
        "
        tooltipPosition="top"
        [feedback]="false"
        [placeholder]="
          field.props['translate']
            ? (field.props.placeholder || '' | translate)
            : field.props.placeholder
        "
      />
      <label *ngIf="field.props.label" [htmlFor]="field.id">{{
        field.props['translate']
          ? (field.props.label | translate)
          : field.props.label
      }}</label>
    </p-iftalabel>
  `,
})
export class FormPasswordFieldType extends FieldType<FieldTypeConfig> {
  @HostBinding('class')
  readonly cssClass = 'form-password-field';
}
